<div class="watch-list-widget">
	<app-watch-list [widget]="widget" />
</div>
